<script lang="ts" setup>
import BuildingStoryItem from '@/components/steps/planning/BuildingStoryItem.vue'
import { BuildingStory } from '@/models/BuildingStory.ts'
import { ValidatorType } from '@/helper/ValidateDirective.ts'

const props = defineProps<{
  validator: ValidatorType
  areStoriesValid: boolean
  buildingStories: BuildingStory[]
}>()

defineExpose({
  validator: props.validator
})

function addBuildingStory() {
  let storyToAdd = new BuildingStory()

  if (props.buildingStories.length === 1) {
    storyToAdd = new BuildingStory({ topStory: true })
    props.buildingStories[0].topStory = false
  }

  props.buildingStories.push(storyToAdd)
}

function removeBuildingStory(index: number) {
  props.buildingStories.splice(index, 1)

  if (props.buildingStories.length === 1) {
    props.buildingStories[0].topStory = true
    props.buildingStories[0].bottomStory = true
  }
}
</script>

<template>
  <div id="building-area" class="form__row">
    <div :class="{ 'is--invalid': !areStoriesValid }" class="form__table options-table">
      <div class="tr">
        <div class="th column is--checkbox">
          <span>{{ $t('step_heating_details.table_head_bottom_story') }}</span>
        </div>
        <div class="th column is--checkbox">
          <span>{{ $t('step_heating_details.table_head_top_story') }}</span>
        </div>
        <div class="th column">
          <span>{{ $t('step_heating_details.table_head_living_area') }}</span>
        </div>
        <div class="th column">
          <span>{{ $t('step_heating_details.table_head_max_room_height') }}</span>
        </div>
        <div class="th column is--delete" />
      </div>

      <BuildingStoryItem
        v-for="(buildingStory, i) in buildingStories"
        :key="buildingStory.id"
        :index="i"
        :validator="validator"
        @remove-item="removeBuildingStory(i)"
      />

      <div class="tr is--add-button-row">
        <div class="td column">
          <button
            id="btn-add-building-story"
            :disabled="buildingStories.length > 4"
            class="btn is--tertiary has--icon-right"
            type="button"
            @click="addBuildingStory()"
          >
            {{ $t('step_heating_details.btn_add_building_story') }} <i class="ic-plus" />
          </button>
        </div>
      </div>
    </div>

    <div :class="{ 'is--invalid': !areStoriesValid }" class="form__element">
      <p v-if="!areStoriesValid" class="form__error">
        {{ $t('validation.building_stories') }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/helpers/include-media';

.options-table {
  margin-bottom: rem-calc(16);
  width: 100%;

  .tr {
    max-height: rem-calc(117);
    transition: all $animTimeBasic ease;

    &:not(.is--add-button-row) {
      display: grid;
      grid-template-columns: 0.55fr 0.55fr 0.75fr 0.75fr 0.25fr;
    }
  }

  .column {
    &.is--checkbox {
      justify-content: center;
    }

    &.is--delete {
      flex-basis: rem-calc(60);
      min-width: rem-calc(60);
      max-width: rem-calc(60);
      flex-shrink: 0;
      flex-grow: 0;
    }
  }
}
</style>
